import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { translateStrict } from '../services/translate';

let serverConsentGiven = false;        
// Traduction sur l'appareil (Translator API du navigateur), si disponible :
// le texte ne quitte alors jamais l'appareil.

async function translateOnDevice(text, source, target) {   // ← ici
  try {
    const Translator = window.Translator;
    if (!source || typeof Translator === 'undefined') return null;
    const opts = { sourceLanguage: source, targetLanguage: target };
    if ((await Translator.availability(opts)) === 'unavailable') return null;
    const translator = await Translator.create(opts);
    return await translator.translate(text);
  } catch {
    return null;
  }
}

const E2EETranslation = ({ text, sourceLang }) => {
 const { t, i18n } = useTranslation();
  const target = (i18n.resolvedLanguage || i18n.language || 'fr').split('-')[0];
  const [status, setStatus] = useState('idle');    // idle | loading | error | unsupported
  const [result, setResult] = useState('');
  const [show, setShow] = useState(false);

  const onClick = async (e) => {
    e.stopPropagation();
    if (result) { setShow(v => !v); return; }
    setStatus('loading');
    try {
      let out = await translateOnDevice(text, sourceLang, target);

      if (!out) {
        //if (!serverConsentGiven) {
        //  const ok = await askConsent(t('discussion.translate_e2ee_warning'));
        //  if (!ok) { setStatus('idle'); return; }
        //  serverConsentGiven = true;
       // }
        out = await translateStrict(text, sourceLang, target);
      }
      setResult(out);
      setShow(true);
      setStatus('idle');
    } catch (err) {
      setStatus(err.response?.status === 422 ? 'unsupported' : 'error');
    }
  };

  return (
    <div style={{ marginTop: 4 }}>
      {show && result && (
        <div style={{
          marginTop: 4, padding: '6px 8px',
          borderLeft: '2px solid var(--color-border-secondary)',
          fontSize: '0.9em', color: 'var(--color-text-secondary)', fontStyle: 'italic',
        }}>
          {result}
        </div>
      )}
      <button
        onClick={onClick}
        disabled={status === 'loading'}
        style={{ background: 'none', border: 'none', padding: 0, fontSize: '0.75em',
                 color: 'var(--color-text-secondary)', cursor: 'pointer' }}
      >
        🌐 {status === 'loading' ? '…'
          : status === 'error' ? t('discussion.translate_error')
          : status === 'unsupported' ? t('discussion.translate_unsupported')
          : show ? t('discussion.hideTranslation')
          : t('discussion.showTranslation')}
      </button>
    </div>
  );
};

export default E2EETranslation;